(function () {
    'use strict';

    angular.module("imApp").factory("orderHeadSetDiscService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1604,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1605,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
